import { useCallback, useEffect } from "react";

interface UseOmnisearchKeyboardShortcutParams {
  onOpen: () => void;
  onClose: () => void;
  isOpen: boolean;
}

export function useOmnisearchKeyboardShortcut(params: UseOmnisearchKeyboardShortcutParams) {
  const { onOpen, onClose, isOpen } = params;

  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      const isMac = navigator.platform.toUpperCase().includes("MAC");
      const isModifierKey = isMac ? event.metaKey : event.ctrlKey;

      if (isModifierKey && event.key.toLowerCase() === "k") {
        event.preventDefault();
        event.stopPropagation();

        if (isOpen) {
          onClose();
        } else {
          onOpen();
        }
      }

      if (event.key === "Escape" && isOpen) {
        event.preventDefault();
        onClose();
      }
    },
    [isOpen, onOpen, onClose]
  );

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);
}
